import { useColorModeValue as mode, Input, Stack, FormControl, FormHelperText, FormLabel, FormErrorMessage } from '@chakra-ui/react'
import { Field, FormikProps } from 'formik';
import * as React from 'react'

import { IApiProjectEditRequest } from '../../../models/api/project/IApiProjectEditRequest';
import { InputFormControl } from '../../formcontrols/InputFormControl';
import { BaseDrawer, IBaseDrawerProps } from '../BaseDrawer';
import { BaseDrawerWithForm } from '../BaseDrawerWithForm';

export interface IEditProjectDrawerProps extends Omit<IBaseDrawerProps<IApiProjectEditRequest>, "defaultValue" | "submitAllowed" | "children" | "saveText" | "discardText" | "headerText" | "isOpen"> {
    defaultValue: IApiProjectEditRequest | undefined;
    readonly: {
        ref: string | undefined;
    }
}

export const EditProjectDrawer = (props: IEditProjectDrawerProps) => {
    return (
        <BaseDrawerWithForm
            isOpen={props.defaultValue !== undefined}
            onSubmit={props.onSubmit}
            onDiscard={props.onDiscard}
            defaultValues={props.defaultValue}
            headerText="Projekt bearbeiten"
        >
            {({ handleSubmit, errors, touched, isSubmitting }: FormikProps<IApiProjectEditRequest>) => (
                <Stack px="0" spacing="4">
                    <FormControl>
                        <FormLabel>Referenz (Geschäftszahl)</FormLabel>
                        <Input isDisabled={true} defaultValue={props.readonly.ref} />
                        <FormHelperText></FormHelperText>
                    </FormControl>
                    <InputFormControl 
                        field="name"
                        label="Name"
                        helperText="Interner Projekttitel"
                        isInvalid={(errors.name && touched.name) ? true : false}
                        isDisabled={isSubmitting}
                        validate={(value: string) => {
                            let error;
                            if (value === null || value === undefined || value.length < 1) {
                                error = "Name ist erforderlich!";
                            }
                            return error;
                        }}
                        errorMessage={errors.name}
                    />
                </Stack>
            )}
        </BaseDrawerWithForm>
    );
}